import { ProductType } from '@inter-ikea-storageone/range';
import { ProductListConfig } from 'rangeConfig/@types';
import addInterior from 'rangeConfig/billy/behaviours/addInterior';
import {
  filterDeskType,
  filterInteriorColors,
  filterInteriorDimensions
} from 'rangeConfig/billy/filters/mainMenuProductFilters';

const interiorsProductListConfig: ProductListConfig = {
  cardsTitle: 'name',
  cardsSubtitle: 'typeName, designText',
  categories: [
    {
      id: 'interiors-w800',
      products: [
        { path: 'type', value: ProductType.BILLY_SHELF },
        { path: 'type', value: ProductType.BILLY_DRAWER },
        { path: 'type', value: ProductType.BILLY_DESK },
        { path: 'communicatedDimensions.width', value: 800 }
      ],
      categoryTitle:
        'storageone.width communicatedDimensionsLocalized.width communicatedDimensionsLocalized.unit'
    },
    {
      id: 'interiors-w400',
      products: [
        { path: 'type', value: ProductType.BILLY_SHELF },
        { path: 'type', value: ProductType.BILLY_DRAWER },
        { path: 'communicatedDimensions.width', value: 400 }
      ],
      categoryTitle:
        'storageone.width communicatedDimensionsLocalized.width communicatedDimensionsLocalized.unit'
    }
  ],
  behaviors: {
    productClicked: [addInterior],
    productDropped: [addInterior]
  },
  cluster: [],
  sortOrder: [],
  productFilters: [filterInteriorDimensions, filterInteriorColors, filterDeskType]
};

export default interiorsProductListConfig;
